import type { InAppNarrowExposureExperiment } from '@post-office/message-template-contracts/message-template-placement-config';

interface ExperimentalMessage {
	messageTemplateId: string;
	statsigExperiment: string;
	statsigParameterName: string;
	statsigTestCohorts: string[];
	statsigAAExperiment?: string;
	/** Replaces the fields above when the narrow exposure migration gate is on. */
	narrowExposureExperiment: InAppNarrowExposureExperiment;
}

// Entries are iterated through using the ML ranking order - the order in the list is not important
export const EXPERIMENTAL_MESSAGES: ExperimentalMessage[] = [
	{
		messageTemplateId: 'confluence-ai-audio-player-spotlight-tour',
		// https://switcheroo.atlassian.com/ui/gates/e9b0503b-0486-48e3-a511-123e409058f4/key/confluence_audio_v3_changeboarding
		statsigExperiment: 'confluence_audio_v3_changeboarding',
		statsigParameterName: 'isEnabled',
		statsigTestCohorts: ['true'],
		// isEnabled is a boolean, so the string cohort above never matches.
		narrowExposureExperiment: {
			statsigExperiment: 'confluence_audio_v3_changeboarding',
			statsigParameterName: 'isEnabled',
			showCohorts: [true],
			dropCohorts: [false],
		},
	},
	{
		messageTemplateId: 'rovo-growth-nudge-end-user-highly-connected-apps',
		// https://switcheroo.atlassian.com/ui/gates/f36896ce-14dc-4a48-9888-dd0df3c671e0/key/rovo_nudge_end_user_highly_connected_apps_exp
		statsigExperiment: 'rovo_nudge_end_user_highly_connected_apps_exp',
		statsigParameterName: 'cohort',
		statsigTestCohorts: ['variant1', 'variant2'],
		narrowExposureExperiment: {
			statsigExperiment: 'rovo_nudge_end_user_highly_connected_apps_exp',
			statsigParameterName: 'cohort',
			showCohorts: ['variant1', 'variant2'],
			dropCohorts: ['control'],
		},
	},
	{
		messageTemplateId: 'cross-flow-product-request-approval',
		// https://switcheroo.atlassian.com/ui/gates/23e1a5f6-5e78-4073-9379-b3bf2583507f/key/pcgrw-522_jpd_invite_toast
		statsigExperiment: 'pcgrw-522_jpd_invite_toast',
		statsigParameterName: 'cohort',
		statsigTestCohorts: ['variation'],
		narrowExposureExperiment: {
			statsigExperiment: 'pcgrw-522_jpd_invite_toast',
			statsigParameterName: 'cohort',
			showCohorts: ['variation'],
			dropCohorts: ['control'],
		},
	},
	{
		messageTemplateId: 'invitations-better-notification-invite-user',
		statsigExperiment: 'twcg-2060-confluence-invite-reminder-flag',
		statsigParameterName: 'cohort',
		statsigTestCohorts: ['treatment'],
		narrowExposureExperiment: {
			statsigExperiment: 'twcg-2060-confluence-invite-reminder-flag',
			statsigParameterName: 'cohort',
			showCohorts: ['treatment'],
			dropCohorts: ['control'],
		},
	},
];
